module.exports = __webpack_public_path__ + "static/zs-curie-f4d84dfc03fa73cc571dc7e274c44ae5.png";